import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';
import Squares2x2Svg from '@/assets/Squares2x2.svg';

const Square2x2 = ({ size, variant, className }: IconProps) => (
  <img
    src={Squares2x2Svg}
    className={cn(iconVariant({ variant, size, className }))}
    aria-hidden="true"
    alt=""
  />
);

export default Square2x2;
